import React, { ReactNode } from 'react';
import { components, ControlProps } from 'react-select';

export const Control = ({ children, ...props }: ControlProps<any, any, any>) => (
  <components.Control {...props}>
    {(props.selectProps as typeof props.selectProps & { prefixContent?: ReactNode }).prefixContent} {children}
  </components.Control>
);
